import { render, staticRenderFns } from "./CurrencyCell.vue?vue&type=template&id=1a39dca6&scoped=true"
import script from "./CurrencyCell.vue?vue&type=script&lang=js"
export * from "./CurrencyCell.vue?vue&type=script&lang=js"
import style0 from "./CurrencyCell.vue?vue&type=style&index=0&id=1a39dca6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39dca6",
  null
  
)

export default component.exports